import {
    IFeatureInfoResponse,
    IFeatureViewNode, IFeatureViewNodeParsed
} from "../types";

import gql from 'graphql-tag';
import {client} from "./client";
import AppConfig from "../../global/appConfig";
import {RequestFeatureInfo} from "../../schema/RequestFeatureInfo";
import {RequestFeatureInfoAdmin} from "../../schema/RequestFeatureInfoAdmin";

export async function requestFeatureInfo (fullUid: string):
    Promise<Array<IFeatureViewNode>> {
    const isAdmin = AppConfig.isAdmin;
    try {
        const result: IFeatureInfoResponse = await client.query({
            query: gql`${isAdmin ? RequestFeatureInfoAdmin: RequestFeatureInfo}`,
            variables: {
                fullUid,
            }
        });
        if (isAdmin) {
            return mapNodes(result.data.allEntitiesviewAdmins.nodes);
        }
        return mapNodes(result.data.allEntitiesviews.nodes);
    } catch (e) {
        return [];
    }
}


function mapNodes (nodes: IFeatureViewNode[] = []): IFeatureViewNodeParsed[] {
    return nodes.map(node => ({
        ...node,
        feature: JSON.parse(node.stAsgeojson)
    }))
}
